module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-3"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title1"
  }, [_vm._v("Helping Stop Hitler’s Luftwaffe")]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_vm._v("The Memoirs of a Pilot Involved in the Development of Radar Interception, Vital in the Battle of Britain")]), _vm._v(" "), _c('h2', {
    staticClass: "author"
  }, [_vm._v("Air Marshal Sir Arthur McDonald")]), _vm._v(" "), _c('p', {
    staticClass: "author2"
  }, [_vm._v("KCB AFC FRAes DL")]), _vm._v(" "), _c('div', {
    staticClass: "img_container1"
  }, [_c('img', {
    staticClass: "wid",
    attrs: {
      "alt": "image",
      "src": "images/Img_3_001.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c5c1d2c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/title.vue
// module id = 60
// module chunks = 0